{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              -86.02670216117419,
              11.052557493086255
            ],
            [
              -85.9994414356058,
              9.756173284620104
            ],
            [
              -83.87229509427546,
              8.535624593914704
            ],
            [
              -82.8450833995305,
              8.004872322836363
            ],
            [
              -82.96327849940664,
              8.292822243674195
            ],
            [
              -82.93664662453277,
              9.100980033207364
            ],
            [
              -82.93612935422999,
              9.47816824968855
            ],
            [
              -82.5087444590895,
              9.594869840826732
            ],
            [
              -83.67230942082058,
              10.900852261189911
            ],
            [
              -84.83586732265096,
              10.936537709173948
            ],
            [
              -85.57217936012343,
              11.24875287080934
            ],
            [
              -85.67210661871232,
              11.07025002738223
            ],
            [
              -86.02670216117419,
              11.052557493086255
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}